import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { navigationTeamIdAtom } from '@/atoms/navigation';
import { TEAM_BASE_ROUTE } from '../useTeamNavigationItem';
import { useTeamDashboardNavigation } from '../useTeamDashboardNavigation';

export const useTeamNavigationItems = () => {
  const { t } = useTranslation('navigation');
  const iqTeamId = useAtomValue(navigationTeamIdAtom);
  const teamRoute = `${TEAM_BASE_ROUTE}/${iqTeamId}`;
  const teamDashboardRoute = useTeamDashboardNavigation();

  return [
    {
      id: 'dashboard',
      label: t('crossPlatform.secondary.dashboard'),
      route: teamDashboardRoute,
    },
    {
      id: 'radar',
      label: t('crossPlatform.secondary.radar'),
      route: `${teamRoute}/radar`,
    },
    {
      id: 'fixtures',
      label: t('crossPlatform.secondary.fixtures'),
      route: `${teamRoute}/fixtures`,
    },
    {
      id: 'results',
      label: t('crossPlatform.secondary.results'),
      route: `${teamRoute}/league-table`,
    },
    {
      id: 'squad',
      label: t('crossPlatform.secondary.squad'),
      route: `${teamRoute}/squad`,
    },
    {
      id: 'player-ages',
      label: t('crossPlatform.secondary.playerAges'),
      route: `${teamRoute}/age-minutes-scatter`,
    },
    {
      id: 'player-comparison',
      label: t('crossPlatform.secondary.playerComparison'),
      route: `${teamRoute}/treemap`,
    },
    {
      id: 'shot-map',
      label: t('crossPlatform.secondary.shotMap'),
      route: `${teamRoute}/shots`,
    },
    {
      id: 'shot-distribution-players',
      label: t('crossPlatform.secondary.shotDistributionPlayers'),
      route: `${teamRoute}/dot-histogram`,
    },
    {
      id: 'shot-distribution-for-and-against',
      label: t('crossPlatform.secondary.shotDistributionForAndAgainst'),
      route: `${teamRoute}/xg-distro`,
    },
    {
      id: 'trendline',
      label: t('crossPlatform.secondary.trendline'),
      route: `${teamRoute}/trendline`,
    },
    {
      id: 'match-time',
      label: t('crossPlatform.secondary.matchTime'),
      route: `${teamRoute}/xg-timing`,
    },
    {
      id: 'corners',
      label: t('crossPlatform.secondary.corners'),
      route: `${teamRoute}/corners`,
    },
    {
      id: 'defensive-activity',
      label: t('crossPlatform.secondary.defensiveActivity'),
      route: `${teamRoute}/heatmap`,
    },
    {
      id: 'similar-teams',
      label: t('crossPlatform.secondary.similarTeams'),
      route: `${teamRoute}/similar`,
    },
    {
      id: 'engine-room',
      label: t('crossPlatform.secondary.engineRoom'),
      route: `${teamRoute}/pass-simulation`,
    },
  ];
};
